"use client";

import React, { useEffect } from "react";

import { Comedian } from "@/data/comedians";
import { LivestreamAndToken } from "@punchup/data/legacy/livestreaming";
import { SpecialEvents } from "@/analytics/mixpanel/mixpanel.types";
import { SpecialRow } from "@/data/specials";
import { trackEvent } from "@/analytics/mixpanel";

const SpecialPageTracker: React.FC<{
  comedian: Pick<
    Comedian,
    "id" | "display_name" | "display_name_short" | "slug" | "about_img"
  >;
  special: SpecialRow;
  livestreamInfo: LivestreamAndToken | null;
}> = ({ comedian, special, livestreamInfo }) => {
  useEffect(() => {
    if (comedian.id && special.id) {
      trackEvent(SpecialEvents.SPECIAL_PAGE_LOADED, {
        ComedianId: comedian.id,
        SpecialId: special.id,
        isSubscriptionContent: special.requires_subscription,
        isLiveVideo: !!livestreamInfo,
        liveState: livestreamInfo?.livestream?.state,
      });
    }
  }, [comedian.id, special.id, special.requires_subscription, livestreamInfo]);
  return <></>;
};

export default SpecialPageTracker;
